<template>
    <div>
        <el-tabs v-model="sellerKind">
            <el-tab-pane label="入选供方公司" :name="1">
                <swb-real-adopted-com-list-select v-if="sellerKind==1" :peerMerchantType="2" :filter="{ peerMerchantType: 2 }" ref="swb_real_adopted_com_select_vendor"></swb-real-adopted-com-list-select>
            </el-tab-pane>
            <el-tab-pane label="入选服方公司" :name="3">
                <swb-real-adopted-com-list-select v-if="sellerKind==3" :peerMerchantType="4" :filter="{ peerMerchantType: 4 }" ref="swb_real_adopted_com_select_servicer"></swb-real-adopted-com-list-select>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import {Utils, $} from '../../app.base'
import {Vue, MsgBox, DomSizeWatcher} from '../../app.vues'

import SwbRealAdoptedComListSelect from '../realCom/RealAdoptedComListSelect'

Vue.regist(SwbRealAdoptedComListSelect)

export default {
    name: 'swb-sellerx-select',
    desc: '临采供应商选择',
    props: {},
    data: function () {
        return {
            sellerKind: 1
        }
    },
    created: function () {
    },
    methods: {
        getDlgResult: function () {
            let result = null;
            if (this.sellerKind == 1) {
                result = this.$refs.swb_real_adopted_com_select_vendor.getDlgResult();
            } else if (this.sellerKind == 2) {
                result = this.$refs.swb_tmp_provider_list_for_select.getDlgResult();
            } else if (this.sellerKind == 3) {
                result = this.$refs.swb_real_adopted_com_select_servicer.getDlgResult();
            }
            result.sellerKind = this.sellerKind;
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/receipt/SellerXSelect.vue